import { useEffect } from 'react'

import cloudIcon from '@web/shared/assets/images/icons/favicon.ico'
import localIcon from '@web/shared/assets/images/icons/logo-blue.svg'
import { useAppSelector } from '@web/shared/utils/use-app-selector.util'

const IPV4_PATTERN =
  /^(?:(?:25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)\.){3}(?:25[0-5]|2[0-4]\d|1\d{2}|[1-9]?\d)$/

const useLocalFavIcon = () => {
  const activeServer = useAppSelector(
    (state) => state.serverSettings.activeServer
  )
  const isDesktop = useAppSelector((state) => state.serverSettings.isDesktop)

  useEffect(() => {
    let favicon = document.querySelector<HTMLLinkElement>("link[rel~='icon']")

    if (!favicon) {
      favicon = document.createElement('link')
      favicon.rel = 'icon'
      document.head.appendChild(favicon)
    }

    const serverHost = isDesktop ? activeServer?.host : window.location.hostname

    favicon.href = IPV4_PATTERN.test(serverHost ?? '') ? localIcon : cloudIcon
  }, [activeServer?.host, isDesktop])
}

export default useLocalFavIcon
